// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"2768f3c4","453":"5fa53271","460":"d815bcdd","490":"53410015","577":"9e885d7b","983":"7358c711"}[chunkId] + ".chunk.js";
};